import { lazy } from "react";
import { Route } from "react-router-dom";
const StatisticPage = lazy(() => import("./Statistic"));

export default (
  <Route
    component={StatisticPage}
  />
);
